import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLayoutEffect } from "react";
import { useRef } from "react";
import { Routes, Route } from "react-router-dom";

import styles from "./App.module.scss";
import CountDown from "./components/CountDown/CountDown";
import MainPage from "./pages/MainPage/MainPage";
import TextArea from "./pages/TextArea/TextArea";
import HyperAndHybrid from "./pages/HyperAndHybrid/HyperAndHybrid";
import EventTimeline from "./pages/EventTimeline/EventTimeline";
import FlexibleKPI from "./pages/FlexibleKPI/FlexibleKPI";
import MillionPrize from "./pages/MillionPrize/MillionPrize";
import HowToWin from "./pages/HowToWin/HowToWin";
import PointTable from "./pages/PointTable/PointTable";
import BonusPrize from "./pages/BonusPrize/BonusPrize";
import Tips from "./pages/Tips/Tips";
import Discord from "./pages/Discord/Discord";
import FAQ from "./pages/FAQ/FAQ";
import GuideLine from "./pages/GuideLine/GuideLine";
import Terms from "./components/Terms/Terms";
import HybridCasual from "./pages/articles/HybridCasual/HybridCasual";
import ImproveMetrics from "./pages/articles/ImproveMetrics/ImproveMetrics";
import PracticalTips from "./pages/articles/PracticalTips/PracticalTips";

function App() {
  gsap.registerPlugin(ScrollTrigger);

  const changeBackgroundRef = useRef();
  const mainPageRef = useRef();
  const hyperAndHybrid = useRef();
  const eventTimeLineRef = useRef();
  const flexibleKpiRef = useRef();
  const millionPrizeRef = useRef();
  const howTowinRef = useRef();
  const pointTableRef = useRef();
  const bonusPrizeRef = useRef();
  const tipsRef = useRef();
  const discordRef = useRef();
  const faqRef = useRef();
  /**1441이상**/
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add("(min-width: 1441px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ff6725",
          immediateRender: false,
          scrollTrigger: {
            trigger: eventTimeLineRef.current,
            markers: false,
            start: "-14% 80%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(min-width:1441px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: flexibleKpiRef.current,
            markers: false,
            start: "-10% 90%",
            scrub: true,
            end: "90% bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width:1441px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#E2FF2D",
          immediateRender: false,
          scrollTrigger: {
            trigger: millionPrizeRef.current,
            markers: false,
            start: "-10% 100%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(min-width:1441px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: howTowinRef.current,
            markers: false,
            start: "-10% 98%",
            scrub: true,
            end: "95% 100%",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width:1441px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ffffff",
          immediateRender: false,
          scrollTrigger: {
            trigger: pointTableRef.current,
            markers: false,
            start: "-5% 90%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(min-width:1441px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#111111",
          immediateRender: false,
          scrollTrigger: {
            trigger: bonusPrizeRef.current,
            markers: false,
            start: "top 80%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width:1441px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ffffff",
          immediateRender: false,
          scrollTrigger: {
            trigger: tipsRef.current,
            markers: false,
            start: "-22% 80%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width:1441px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: discordRef.current,
            markers: false,
            start: "-7% 90%",
            scrub: true,
            end: "90% bottom",
            snap: false,
          },
        });
      });
    });
    return () => ctx.revert();
  });

  /**769< Screen < 1440**/
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add("(min-width: 769px) and (max-width:1440px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ff6725",
          immediateRender: false,
          scrollTrigger: {
            trigger: eventTimeLineRef.current,
            markers: false,
            start: "-25% 95%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(min-width: 769px) and (max-width:1440px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: flexibleKpiRef.current,
            markers: false,
            start: "top 95%",
            scrub: true,
            end: "95% bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width: 769px) and (max-width:1440px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#E2FF2D",
          immediateRender: false,
          scrollTrigger: {
            trigger: millionPrizeRef.current,
            markers: false,
            start: "-5% 100%",
            scrub: true,
            end: "55% 55%",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(min-width: 769px) and (max-width:1440px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: howTowinRef.current,
            markers: false,
            start: "-15% 98%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width: 769px) and (max-width:1440px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ffffff",
          immediateRender: false,
          scrollTrigger: {
            trigger: pointTableRef.current,
            markers: false,
            start: "top 90%",
            scrub: true,
            end: "30% bottom",
          },
        });
      });

      gsap.matchMedia().add("(min-width: 769px) and (max-width:1440px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#111111",
          immediateRender: false,
          scrollTrigger: {
            trigger: bonusPrizeRef.current,
            markers: false,
            start: "-25% 90%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width: 769px) and (max-width:1440px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ffffff",
          immediateRender: false,
          scrollTrigger: {
            trigger: tipsRef.current,
            markers: false,
            start: "-17% 80%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width: 769px) and (max-width:1440px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: discordRef.current,
            markers: false,
            start: "-10% 90%",
            scrub: true,
            end: "110% bottom",
            snap: false,
          },
        });
      });
    });
    return () => ctx.revert();
  });

  /** 769 =>Screen **/
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add("(min-width:481px) and (max-width:768px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ff6725",
          immediateRender: false,
          scrollTrigger: {
            trigger: eventTimeLineRef.current,
            markers: false,
            start: "top 80%",
            scrub: true,
            end: "top top",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(min-width:481px) and (max-width:768px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: flexibleKpiRef.current,
            markers: false,
            start: "top 95%",
            scrub: true,
            end: "95% bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width:481px) and (max-width:768px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#E2FF2D",
          immediateRender: false,
          scrollTrigger: {
            trigger: millionPrizeRef.current,
            markers: false,
            start: "top 100%",
            scrub: true,
            end: "60% 55%",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(min-width:481px) and (max-width:768px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: howTowinRef.current,
            markers: false,
            start: "-15% 98%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width:481px) and (max-width:768px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ffffff",
          immediateRender: false,
          scrollTrigger: {
            trigger: pointTableRef.current,
            markers: false,
            start: "-5% 90%",
            scrub: true,
            end: "10% 5%",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(min-width:481px) and (max-width:768px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#111111",
          immediateRender: false,
          scrollTrigger: {
            trigger: bonusPrizeRef.current,
            markers: false,
            start: "-15% 50%",
            scrub: true,
            end: "50% bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width:481px) and (max-width:768px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ffffff",
          immediateRender: false,
          scrollTrigger: {
            trigger: tipsRef.current,
            markers: false,
            start: "top 80%",
            scrub: true,
            end: "10% 60%",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(min-width:481px) and (max-width:768px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: discordRef.current,
            markers: false,
            start: "-10% 90%",
            scrub: true,
            end: "110% bottom",
            snap: false,
          },
        });
      });
    });
    return () => ctx.revert();
  });

  /** 480 =>Screen **/
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add("(max-width: 480px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ff6725",
          immediateRender: false,
          scrollTrigger: {
            trigger: eventTimeLineRef.current,
            markers: false,
            start: "-20% 20%",
            scrub: true,
            end: "top top",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(max-width: 480px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: flexibleKpiRef.current,
            markers: false,
            start: "-15% 98%",
            scrub: true,
            end: "center 80%",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(max-width:480px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#E2FF2D",
          immediateRender: false,
          scrollTrigger: {
            trigger: millionPrizeRef.current,
            markers: false,
            start: "-10% 50%",
            scrub: true,
            end: "center top",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(max-width:480px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: howTowinRef.current,
            markers: false,
            start: "top 98%",
            scrub: true,
            end: "bottom bottom",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(max-width: 480px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ffffff",
          immediateRender: false,
          scrollTrigger: {
            trigger: pointTableRef.current,
            markers: false,
            start: "-5% 90%",
            scrub: true,
            end: "10% 5%",
            snap: false,
          },
        });
      });

      gsap.matchMedia().add("(max-width: 480px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#111111",
          immediateRender: false,
          scrollTrigger: {
            trigger: bonusPrizeRef.current,
            markers: false,
            start: "-30% 50%",
            scrub: true,
            end: "top top",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(max-width: 480px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#ffffff",
          immediateRender: false,
          scrollTrigger: {
            trigger: tipsRef.current,
            markers: false,
            start: "top 80%",
            scrub: true,
            end: "30% 50%",
            snap: false,
          },
        });
      });
      gsap.matchMedia().add("(max-width: 480px)", () => {
        gsap.to(changeBackgroundRef.current, {
          "--color": "#3cadff",
          immediateRender: false,
          scrollTrigger: {
            trigger: discordRef.current,
            markers: false,
            start: "-10% 90%",
            scrub: true,
            end: "110% bottom",
            snap: false,
          },
        });
      });
    });
    return () => ctx.revert();
  });
  return (
    <div className={styles.container}>
      <Routes>
        <Route
          path="/"
          element={
            <>
              {/* <CommingSoon /> */}
              <div
                className={styles.change_background}
                ref={changeBackgroundRef}
              >
                <CountDown />
                <MainPage mainPageRef={mainPageRef} />
                <TextArea />
                <HyperAndHybrid hyperAndHybrid={hyperAndHybrid} />
                <EventTimeline eventTimeLineRef={eventTimeLineRef} />
                <FlexibleKPI flexibleKpiRef={flexibleKpiRef} />
                <MillionPrize millionPrizeRef={millionPrizeRef} />
                <HowToWin howTowinRef={howTowinRef} />
                <PointTable pointTableRef={pointTableRef} />
                <BonusPrize bonusPrizeRef={bonusPrizeRef} />
                <Tips tipsRef={tipsRef} />
                <Discord discordRef={discordRef} />
                <FAQ faqRef={faqRef} />
                <GuideLine />
              </div>
            </>
          }
        />
        <Route path="/hybrid-casual" element={<HybridCasual />} />
        <Route path="/improve-metrics" element={<ImproveMetrics />} />
        <Route path="/practical-tips" element={<PracticalTips />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </div>
  );
}

export default App;
